import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";

const getReturnOrders =
    ({ page = 0, sizeperpage = 0, search = "", filter = {} } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_RETURN_ORDER", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            axios
                .get(`/api/return-orders?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_RETURN_ORDER", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "ADMIN_LIST_RETURN_ORDER",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_RETURN_ORDER", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

const getReturnRecordsById = (data) => (dispatch, getState) => {

    dispatch({ type: "LOADING_RETURN_ORDER", payload: true });
    return axios
        .post("/api/return-orders/search-record", data, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {

                dispatch({ type: "LOADING_RETURN_ORDER", payload: false });
                if (res?.data?.data?.length > 0) {
                    return res.data.data;

                } else {
                    Swal.fire(t("Error"), t("No Record!"), "error");
                    return [];
                }
            } else {
                dispatch({ type: "LOADING_RETURN_ORDER", payload: false });
                Swal.fire(t("Error"), t("Find record failed!"), "error");
                return [];
            }
        })
        .catch((err) => {
            dispatch({ type: "LOADING_RETURN_ORDER", payload: false });
            Swal.fire(t("Error"), t("An error occurred!"), "error");
            return [];
        });
};

const exportReturnOrders =
    ({ page = 0, sizeperpage = 0, search = "", filter = {} } = {}) =>
        async (dispatch, getState) => {
            dispatch({ type: "LOADING_RETURN_ORDER", payload: true });

            let page = 1;
            const sizeperpage = 250;
            let allData = [];
            let hasMore = true;

            // var param_search = "";
            // if (search !== "") {
            //     param_search = `&search=${search}`;
            // }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            try {
                while (hasMore) {
                    const res = await axios
                        .post(`/api/return-orders/export?page=${page}&sizeperpage=${sizeperpage}${filter}`, { search }, tokenConfig(getState));
                    if (res.data.status !== 200) {
                        throw new Error(res.data.message);
                    }

                    const data = res.data.data.all_return_orders_for_export;
                    allData = [...allData, ...data];

                    if (data.length < sizeperpage) {
                        hasMore = false;
                    } else {
                        page++;
                    }
                }

                dispatch({
                    type: "EXPORT_RETURN_ORDER",
                    payload: { all_return_orders_for_export: allData },
                });
            } catch (err) {
                // console.log(err);
                Swal.fire("Error", "Export failed!", "error");
            } finally {
                dispatch({ type: "LOADING_RETURN_ORDER", payload: false });
            }
        };

const saveEditReturnOrder =
    (data, closemodal = () => { }) =>
        (dispatch, getState) => {
            var body = {
                _id: data?._id,
                keywords: data?.keywords,
            };
            // Swal.fire({
            // 	title: t("Are you sure?"),
            // 	text: t("Are you sure to edit order?"),
            // 	icon: 'warning',
            // 	showCancelButton: true,
            // 	confirmButtonColor: '#3085d6',
            // 	cancelButtonColor: '#d33',
            // 	confirmButtonText: t("Sure"),
            // 	cancelButtonText: t("Cancel")
            // }).then((result) => {
            // 	if (result.value) {
            dispatch({ type: "LOADING_ORDER", payload: true });
            axios
                .post("/api/return-orders/edit", body, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    if (res.data.status === 200) {
                        closemodal();
                        dispatch(
                            getReturnOrders({
                                page: data.page,
                                sizeperpage: data.sizePerPage,
                                search: data.search,
                                filter: data.filter,
                            })
                        );
                        // Swal.fire(t("Success"), t(res.data.message), 'success');
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_ORDER", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });

            // 	}
            // })
        };

export {
    getReturnOrders,
    getReturnRecordsById,
    exportReturnOrders,
    saveEditReturnOrder,
}
